import { Fab, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { isPublicPage } from "@/utils/visualBuilder";

import { TAB_STATUSES } from "../../../constants";
import { AddWhite, CheckMark } from "../../../icons";

const useStyles = makeStyles({
  collectButton: {
    backgroundColor: "#323232",
    "&:hover": {
      backgroundColor: "#323232",
    },

    "& svg": {
      width: 16,
      height: 16,
    },
  },
  tooltip: {
    backgroundColor: "#fff",
    color: "black",
    fontSize: "12px ",
    lineHeight: "16px",
    borderRadius: "2px",
  },
  arrow: {
    color: "#fff",
  },
});

interface CollectButtonProps {
  tabStatus: string;
  gridView: boolean;
  selectedItems: Record<string, unknown>; // TODO: Define type
  fabToggle: React.MouseEventHandler<HTMLButtonElement>;
  collectedStatus: () => boolean;
  disabled?: boolean;
}

export default function CollectButton(props: CollectButtonProps) {
  const { tabStatus, gridView, selectedItems, fabToggle, collectedStatus, disabled = false } = props;

  const classes = useStyles();

  const showFab = () => {
    let show = false;

    if (
      tabStatus === TAB_STATUSES.HOMEBASE ||
      tabStatus === TAB_STATUSES.COLLECT ||
      tabStatus === TAB_STATUSES.CUSTOMIZE
    ) {
      show = true;
    }

    if (isPublicPage(tabStatus)) {
      return false;
    }

    if (gridView) {
      if (Object.keys(selectedItems).length > 0) {
        show = true;
      } else {
        show = false;
      }
    }

    return show;
  };

  return (
    showFab() && (
      <Tooltip
        data-testid="collect-button"
        classes={{
          arrow: classes.arrow,
          tooltip: classes.tooltip,
        }}
        title={collectedStatus() ? "Collect this Content" : "Un-collect this Content"}
        placement="left"
        arrow
      >
        <Fab className={classes.collectButton} size="small" onClick={fabToggle} disabled={disabled}>
          {collectedStatus() ? <AddWhite /> : <CheckMark htmlColor="#fff" />}
        </Fab>
      </Tooltip>
    )
  );
}
